/**
 * Yup `.test()` config that rejects phone numbers which are not exactly 8 digits.
 * Empty values pass so combine with `.required()` separately for mandatory phone
 * fields.
 *
 * @example
 * Yup.string()
 *   .required(t('errorMessage.pleaseEnter'))
 *   .test(eightDigitPhone(t('errorMessage.phoneMustBeEightDigits')))
 */
export function eightDigitPhone(message: string) {
	return {
		name: 'eightDigitPhone',
		message,
		test: (value?: string | null) => !value || /^\d{8}$/.test(value.trim()),
	};
}
